<script>import { getTranslation } from "./stores";
export let id;
export let args = void 0;
export let attr = void 0;
$:
  translation = $getTranslation(id, args);
</script>

<slot text={translation.value} attrs={translation.attributes}>
	{attr ? translation.attributes[attr] : translation.value}
</slot>
